import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import menuArrow from 'images/lng-switch-arrow.png';
import { rem } from 'polished';
import { getFlagFromLanguage } from 'utils/getCountryFlagFromLanguage';

const Container = styled.div<{ lngMenuIsHalfOpen: boolean }>`
  display: ${({ lngMenuIsHalfOpen }) =>
    lngMenuIsHalfOpen ? 'none' : 'inline-flex'};
  align-items: center;
  align-self: end;
`;

const CurrentLanguage = styled.p`
  color: #fff;
  font-weight: ${(props) => props.theme.fontWeights.bold};
  font-size: ${rem(16)};
  line-height: 24px;

  margin-left: 4px;
  margin-right: 16px;
`;

const CountryFlag = styled.img``;
const OpenLngMenuArrow = styled.img``;

interface LanguageDisplayProps {
  setLngMenuIsHalfOpen: (bool: bool) => void;
  lngMenuIsHalfOpen: boolean;
}

const LanguageDisplay = ({
  setLngMenuIsHalfOpen,
  lngMenuIsHalfOpen,
}: LanguageDisplayProps) => {
  const { i18n } = useTranslation();
  const languageFlag = getFlagFromLanguage(i18n.language);

  return (
    <Container
      onClick={() => setLngMenuIsHalfOpen(true)}
      lngMenuIsHalfOpen={lngMenuIsHalfOpen}
    >
      <CountryFlag src={languageFlag} alt="" aria-hidden="true" />
      <CurrentLanguage>{i18n.language.toUpperCase()}</CurrentLanguage>
      <OpenLngMenuArrow src={menuArrow} alt="Menu" />
    </Container>
  );
};

export default LanguageDisplay;
